"use client";
import React from "react";
import { motion } from "framer-motion";

interface MarqueeProps {
  text?: string;
  speed?: number;
  className?: string;
}

export function Marquee({ 
  text = "WHERE HOMES ARE MASTERPIECES — AND OWNERS ARE FREE", 
  speed = 50,
  className = ""
}: MarqueeProps) {
  // Create multiple instances of the text for seamless scrolling
  const repeatedText = Array(6).fill(text).join(" • ");

  return (
    <div 
      className={`relative overflow-hidden w-full ${className}`}
      style={{ 
        height: '59px',
        backgroundColor: '#103236'
      }}
    >
      <div className="absolute inset-0 flex items-center">
        <motion.div
          className="flex items-center whitespace-nowrap"
          animate={{
            x: [0, -2000], // Animate from right to left
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: speed,
              ease: "linear",
            },
          }}
          style={{
            width: 'max-content'
          }}
        >
          <span 
            className="text-white text-xs font-medium tracking-wider uppercase"
            style={{ 
              fontSize: '12px',
              letterSpacing: '0.1em'
            }}
          >
            {repeatedText}
          </span>
        </motion.div>
      </div>
    </div>
  );
}

export function HudsonMarquee() {
  const marqueeTexts = [
    "WHERE HOMES ARE MASTERPIECES — AND OWNERS ARE FREE",
    "WE MAINTAIN YOUR HOME SO YOU DON'T HAVE TO.",
    "A PRIVATE MEMBERSHIP FOR DISCERNING HOMEOWNERS",
    "EFFORTLESS HOMEOWNERSHIP • PRECISION CARE • PROACTIVE PLANNING"
  ];

  return (
    <div className="w-full">
      {marqueeTexts.map((text, index) => (
        <Marquee 
          key={index}
          text={text}
          speed={40 + (index * 5)} // Slightly different speeds for variety
          className={index > 0 ? "mt-0" : ""}
        />
      ))}
    </div>
  );
}

export function SingleMarquee() {
  return (
    <Marquee 
      text="WE MAINTAIN YOUR HOME SO YOU DON'T HAVE TO • WHERE HOMES ARE MASTERPIECES — AND OWNERS ARE FREE"
      speed={60}
    />
  );
} 